












import Vue from 'vue';

export default Vue.extend({
  name: 'AfterCreatingOpportunityModal',
  props: {
    isOpen: Boolean,
  },
  data() {
    return {
      showModal: this.isOpen,
    };
  },
});
